<template>
    <v-container class="pa-5" fluid>
        <AddShipmentsOrderDialog
            :is-open="addShipmentsOrderDialog"
            @on-close="closeAddShipmentsOrderDialog"
        />
        <ShipmentsOrderHistoryDialog
            :shipping-order-data="shippingOrder"
            :is-open="shippingOrderHistoryDialog"
            @show-shipping-order-history-dialog="shippingOrderHistoryDialog = true"
            @on-close="closeShipmentsOrderHistoryDialog"
        />
        <CreateShipmentOrderByCampaignDialog
            v-if="createShipmentOrderByCampaignDialog"
            :is-open="createShipmentOrderByCampaignDialog"
            :delivery-methods="deliveryMethods"
            @create-shipments-order-from-orders="createShipmentOrderFromOrders"
            @on-close="closeCreateShipmentOrderByCampaignDialog"
        />
        <page-title>Zlecenia spedycyjne</page-title>
        <v-row align="center">
            <v-col cols="12" sm="4" lg="4">
                <v-col>
                    <v-btn
                        color="secondary"
                        class="mb-2"
                        medium
                        data-sentry-label="Importuj z Print Managera"
                        @click="createShipmentsOrder"
                    >
                        <v-icon left>
                            mdi-plus
                        </v-icon>
                        Importuj z Print Managera
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn
                        color="secondary"
                        medium
                        data-sentry-label=" Utwórz z kampanii"
                        @click="showCreateShipmentOrderByCampaignDialog"
                    >
                        <v-icon left>
                            mdi-plus
                        </v-icon>
                        Utwórz z kampanii
                    </v-btn>
                </v-col>
            </v-col>
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4" class="d-flex justify-end">
                            <v-checkbox
                                v-model="filters.isProperlyValidated"
                                label="ZS, których nie można przesłać do XL"
                                hide-details
                                class="mt-2 mr-3"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select
                                v-model="filters.status_id"
                                label="Status"
                                :items="shippingOrderStatuses"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono statusu"
                                solo
                                clearable
                                hide-details
                                @change="changeFilter"
                                @click:clear="clearFilter('status_id')"
                            />
                        </v-col>
                        <v-col cols="12" sm="5" md="4" lg="4">
                            <v-text-field
                                v-model="filters.number"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('number')"
                            />
                        </v-col>
                    </v-row>
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="4" md="6">
                            <v-text-field
                                v-model="filters.shippingOrderCustomer__name"
                                label="Klient"
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('shippingOrderCustomer__name')"
                            />
                        </v-col>
                        <v-col cols="12" sm="5" md="6" lg="6">
                            <v-autocomplete
                                v-model="filters.createdBy_id"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Tworzący"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                clearable
                                cache-items
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('createdBy_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="end" dense>
                        <v-col cols="12" md="3">
                            <v-menu
                                v-model="creationDateMenuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.orderCreated__gte"
                                        label="Zamówienie od"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('orderCreated__gte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.orderCreated__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="creationDateMenuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-menu
                                v-model="creationDateMenuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.orderCreated__lte"
                                        label="Zamówienie do"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('orderCreated__lte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.orderCreated__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="creationDateMenuTo = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.shippingDate__gte"
                                        label="Wysyłka od"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('shippingDate__gte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.shippingDate__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.shippingDate__lte"
                                        label="Wysyłka do"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        solo
                                        hide-details
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('shippingDate__lte')"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="filters.shippingDate__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="generateReportLoading"
                    @click="generateReport"
                >
                    <v-icon
                        v-if="!generateReportLoading"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="shippingOrders"
                        :loading="shippingOrdersLoading"
                        :page.sync="pagination.page"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="shippingOrdersData"
                        @pagination="updatePagination"
                    >
                        <template #item="{item}">
                            <tr :class="{'isSelected': selectedShipmentsOrderId == item.id}">
                                <td :class="shippingOrderClass(item.isProperlyValidated)">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-icon v-if="item.inProduction" color="orange" v-on="on">
                                                mdi-progress-wrench
                                            </v-icon>
                                            <v-icon v-else color="grey lighten-2">
                                                mdi-progress-wrench
                                            </v-icon>
                                        </template>
                                        <span>W produkcji</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    <template v-if="item.number">
                                        {{ item.number }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    {{ item.shippingOrderCustomer.name }}
                                </td>
                                <td class="text-center">
                                    <template v-if="item.status">
                                        {{ item.status.name }}
                                    </template>
                                </td>
                                <td class="text-center">
                                    <template v-if="item.createdBy && item.createdBy.firstName && item.createdBy.lastName">
                                        {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td class="text-center">
                                    {{ formatDate(item.createdAt) }}
                                </td>
                                <td class="text-center">
                                    {{ setExpeditionDateTime(item) }}
                                </td>
                                <td class="text-center">
                                    {{ setDeliveryDateTime(item) }}
                                </td>
                                <td class="text-center">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Drukuj"
                                                    :disabled="!hasShipmentsOrderPackages(item)"
                                                    v-on="on"
                                                    @click="printShipmentsOrder(item.id)"
                                                >
                                                    <v-icon color="blue">
                                                        mdi-printer
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Drukuj</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Metryka dokumentu"
                                                    v-on="on"
                                                    @click="showShipmentsOrderHistoryDialog(item)"
                                                >
                                                    <v-icon color="blue-grey">
                                                        mdi-file-document
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Metryka dokumentu</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Otwórz"
                                                    v-on="on"
                                                    @click="openShipmentsOrder(item.id)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-ballot
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Otwórz</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import ShipmentsOrderHistoryDialog from './ShipmentsOrderHistoryDialog'
import CreateShipmentOrderByCampaignDialog from './CreateShipmentOrderByCampaignDialog'
import AddShipmentsOrderDialog from './AddShipmentsOrderDialog'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'

import { openPdfFile } from '@/utils/pdfHandler'

let searchTimer

export default {
    name: 'ShipmentsOrdersList',
    components: {
        PageTitle,
        ShipmentsOrderHistoryDialog,
        CreateShipmentOrderByCampaignDialog,
        AddShipmentsOrderDialog
    },
    mixins: [
        pagination,
        tooltipDelay,
        filters,
        dateFormatter,
        customFilters,
        dataTableClassSetter
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('shipments/shipmentsOrders/clearShipmentsOrdersFilters')
            this.clearSelectedListItemId()
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            shippingOrder: {
                changesHistory: []
            },
            shippingOrderHistoryDialog: false,
            shippingOrderHistoryLoading: false,
            createShipmentOrderByCampaignDialog: false,
            addShipmentsOrderDialog: false,
            generateReportLoading: false,
            creationDateMenuFrom: false,
            creationDateMenuTo: false,
            menuFrom: false,
            menuTo: false,
            usersSearch: null,
            users: [],
            usersSearchLoading: false,
            deliveryMethods: [],
            headers: [
                {
                    sortable: false,
                    width: 30,
                },
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false,
                    width: 120
                },
                {
                    text: 'Klient',
                    value: 'shippingOrderCustomer',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Utworzone przez',
                    value: 'createdBy',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Planowana data wysyłki',
                    value: 'expeditionDateTime',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Data dostawy',
                    value: 'deliveryDateTime',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 120
                }
            ]
        }
    },
    computed: {
        userEmail() {
            return this.$store.state.user.userEmail
        },
        shippingOrders() {
            return this.$store.state.shipments.shipmentsOrders.shipmentsOrders.shippingOrders
        },
        shippingOrdersLoading() {
            return this.$store.state.shipments.shipmentsOrders.shipmentsOrders.shippingOrdersLoading
        },
        savedFilters() {
            return this.$store.state.shipments.shipmentsOrders.shipmentsOrders.shippingOrdersFilters
        },
        shippingOrderStatuses() {
            return this.$store.state.shipments.shipmentsOrders.shipmentsOrders.shippingOrderStatuses
        },
        selectedShipmentsOrderId() {
            return this.$store.state.common.selectedListItemId
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        Promise.all([
            this.$store.dispatch('shipments/shipmentsOrders/getShipmentsOrderStatuses'),
            this.getDeliveryMethods()
        ])
            .then(() => {
                this.getShipmentsOrders()
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        async getDeliveryMethods() {
            const query = '?isAvailableInTransportSelection=true'

            return await this.$store.dispatch('shipments/shipmentsOrders/getDeliveryMethods', { query })
                .then(response => {
                    this.deliveryMethods = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika na liście zleceń spedycyjnych')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        getShipmentsOrders() {
            this.$store.dispatch('shipments/shipmentsOrders/getShipmentsOrders', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        printShipmentsOrder(shippingOrderId) {
            this.$store.dispatch('shipments/shipmentsOrders/printShipmentsOrder', shippingOrderId)
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        openShipmentsOrder(shippingOrderId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(shippingOrderId)
            this.$router.push({
                name: 'shipmentsShipmentsOrdersShipmentsOrder',
                params: { shippingOrderId: shippingOrderId }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        setDeliveryDateTime(shippingOrder) {
            let deliveryDateTime = ''

            if (shippingOrder.shippingOrderPositions.length > 0) {
                deliveryDateTime = shippingOrder.shippingOrderPositions[0].deliveryDateTime
            }

            return this.formatDate(deliveryDateTime)
        },
        setExpeditionDateTime(shippingOrder) {
            let expeditionDateTime = ''

            if (shippingOrder.shippingOrderPositions.length > 0) {
                expeditionDateTime = shippingOrder.shippingOrderPositions
                    .map(
                        position => Date.parse(position.expeditionDateTime)
                    )
                    .sort()
                    .at(0)
            }

            return this.formatDate(expeditionDateTime)
        },
        hasShipmentsOrderPackages(shippingOrder) {
            return shippingOrder.shippingOrderPositions.length > 0
        },
        shippingOrderClass(boolean) {
            return boolean ? 'v-data-table__label v-data-table__label--success' : 'v-data-table__label v-data-table__label--danger'
        },
        async showShipmentsOrderHistoryDialog(item) {
            const shippingOrderId = item?.id

            if (!shippingOrderId) return

            if (this.shippingOrderHistoryLoading) return

            this.shippingOrderHistoryLoading = true

            this.shippingOrderHistoryDialog = false
            this.$store.dispatch('toggleCircularLoader', true)

            try {
                const response = await this.$store.dispatch('shipments/shipmentsOrders/getShipmentsOrderChangesHistory', shippingOrderId)
                const changesHistory = response?.data?.results || []

                this.shippingOrder = {
                    ...item,
                    changesHistory
                }
                this.shippingOrderHistoryDialog = true
            } catch (error) {
                errorHandler(error)
            } finally {
                this.$store.dispatch('toggleCircularLoader', false)
                this.shippingOrderHistoryLoading = false
            }
        },
        closeShipmentsOrderHistoryDialog() {
            this.shippingOrderHistoryDialog = false
        },
        createShipmentsOrder() {
            this.addShipmentsOrderDialog = true
        },
        closeAddShipmentsOrderDialog() {
            this.addShipmentsOrderDialog = false
        },
        changeFilter() {
            this.$store.dispatch('shipments/shipmentsOrders/setShipmentsOrdersFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()
            this.getShipmentsOrders()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getShipmentsOrders()
            }
            this.clearPaginationPending()
        },
        generateReport() {
            this.generateReportLoading = true
            this.$store.dispatch('shipments/shipmentsOrders/generateReport', {
                query: this.filterQuery,
                userEmail: this.userEmail
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.generateReportLoading = false
                })
        },
        showCreateShipmentOrderByCampaignDialog() {
            this.createShipmentOrderByCampaignDialog = true
        },
        closeCreateShipmentOrderByCampaignDialog() {
            this.createShipmentOrderByCampaignDialog = false
        },
        createShipmentOrderFromOrders(orderProducts) {
            this.$store.dispatch('shipments/shipmentsOrders/createShipmentOrderFromOrders', orderProducts)
                .then(() => {
                    this.getShipmentsOrders()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeCreateShipmentOrderByCampaignDialog()
                })
        }
    }
}
</script>
